import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  // Step 1: Basic Information
  fullName: "",
  email: "",
  phone: "",
  country: "",

  // Step 2: Why Impactoverse
  whyJoin: "",
  causes: [],

  // Step 3: Social Media Accounts
  socialLinks: {
    instagram: "",
    youtube: "",
    facebook: "",
    linkedin: "",
  },
  followers: {
    instagram: "",
    youtube: "",
    facebook: "",
    linkedin: "",
  },
  audienceDemographics: "",
  nicheCategory: "",

  // Step 4: Contact and Social
  platforms: [],
  preferredContact: "email",
  termsAgreed: false,
};

const influencerVerificationSlice = createSlice({
  name: "influencerVerification",
  initialState,
  reducers: {
    updateInfluencerVerification: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    resetInfluencerVerification: () => initialState,
  },
});

export const { updateInfluencerVerification, resetInfluencerVerification } =
  influencerVerificationSlice.actions;

export default influencerVerificationSlice.reducer;
